var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25409_16528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.49995 12.9466C0.499916 13.3681 0.989458 13.6005 1.31605 13.334L2.9757 11.9798H13.2918C13.9586 11.9798 14.5 11.4108 14.5 10.7099V3.26889C14.5 2.56863 13.9586 2 13.2918 2H1.70846C1.04124 2 0.500217 2.56829 0.500217 3.26924V9.67778L0.49995 12.9466Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5C3.5 5.22386 3.72386 5 4 5H9.5C9.77614 5 10 5.22386 10 5.5C10 5.77614 9.77614 6 9.5 6H4C3.72386 6 3.5 5.77614 3.5 5.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5C3.5 7.22386 3.72386 7 4 7H6C6.27614 7 6.5 7.22386 6.5 7.5C6.5 7.77614 6.27614 8 6 8H4C3.72386 8 3.5 7.77614 3.5 7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6943 22.3776L21.6667 20.8115H8.96912C8.15826 20.8115 7.5 20.1951 7.5 19.4357V10.3746C7.5 9.61602 8.15826 9 8.96912 9H23.0304C23.8417 9 24.4996 9.61564 24.4996 10.375V18.3176L24.4999 21.9819C24.4999 22.3972 24.0229 22.6315 23.6943 22.3776Z",
    fill: "url(#paint0_linear_25409_16528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13.648C21.5 13.2901 21.2099 13 20.852 13H11.148C10.7901 13 10.5 13.2901 10.5 13.648C10.5 14.0058 10.7901 14.2959 11.148 14.2959H20.852C21.2099 14.2959 21.5 14.0058 21.5 13.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.2398C21.5 15.8819 21.2099 15.5918 20.852 15.5918H15.648C15.2901 15.5918 15 15.8819 15 16.2398C15 16.5976 15.2901 16.8877 15.648 16.8877H20.852C21.2099 16.8877 21.5 16.5976 21.5 16.2398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25409_16528",
    x1: 15.6136,
    y1: 15.6818,
    x2: 8.00227,
    y2: 23.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A2A0FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25409_16528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c6b88d94ae413dc9aa49f743cc0bbe8b.svg";
export { ForwardRef as ReactComponent };